<template>
  <!-- Casella obbligatoria del passaggio a ristrutturazione (#3234): il testo è
       composto dalle stesse parti che la richiesta salva in shareConsent
       (consent/shareConsent.js). Stesso stile della spunta privacy. -->
  <label class="ic-form__privacy">
    <input
      :data-testid="testId"
      type="checkbox"
      :checked="modelValue"
      @change="$emit('update:modelValue', $event.target.checked)"
    />
    <span :data-testid="`${testId}-text`">{{ parts.before }}<a
        :data-testid="`${testId}-link`"
        class="ic-form__privacy-link"
        :href="policyUrl"
        target="_blank"
        rel="noopener noreferrer"
      >{{ parts.link }}</a>{{ parts.after }}</span>
  </label>
</template>

<script>
import { RENOVATION_PARTNER, SHARE_CONSENT_POLICY_URL, shareConsentParts } from "@/consent/shareConsent.js";

export default {
  name: "ShareConsentCheckbox",
  props: {
    modelValue: { type: Boolean, default: false },
    testId: { type: String, default: "share" },
    partnerName: { type: String, default: RENOVATION_PARTNER.name },
  },
  emits: ["update:modelValue"],
  data() {
    return { policyUrl: SHARE_CONSENT_POLICY_URL };
  },
  computed: {
    parts() {
      return shareConsentParts(this.partnerName);
    },
  },
};
</script>
